jQuery(function($){
    $('#search-popup').on('shown.bs.modal', function(e){
        $( 'input[name="s"]' ).focus();
    });
});
